// API client for PURSUE FR backend
import axios from 'axios';

const BACKEND_URL = process.env.REACT_APP_BACKEND_URL;
export const API = `${BACKEND_URL}/api`;

export const apiClient = axios.create({ baseURL: API, timeout: 30000 });

// --- Endpoints ---
export async function fetchStats() {
  const { data } = await apiClient.get('/stats');
  return data;
}

export async function fetchDossiers({ agency, q, limit = 200, skip = 0 } = {}) {
  const params = {};
  if (agency && agency !== 'ALL') params.agency = agency;
  if (q) params.q = q;
  params.limit = limit;
  params.skip = skip;
  const { data } = await apiClient.get('/dossiers', { params });
  return data; // { total, items }
}

export async function fetchDossier(id) {
  const { data } = await apiClient.get(`/dossiers/${id}`);
  return data;
}

export function imageUrl(path) {
  if (!path) return null;
  if (path.startsWith('http')) return path;
  return `${BACKEND_URL}${path}`;
}

export function downloadImageUrl(filename) {
  if (!filename) return null;
  return `${BACKEND_URL}/api/download/image/${filename}`;
}

// --- Visitor counter ---
function _getFingerprint() {
  let fp = localStorage.getItem('pursue_fr_fp');
  if (!fp) {
    fp = `${Date.now().toString(36)}-${Math.random().toString(36).slice(2, 12)}`;
    localStorage.setItem('pursue_fr_fp', fp);
  }
  return fp;
}

export async function trackVisit() {
  try {
    const { data } = await apiClient.post('/visits/track', { fingerprint: _getFingerprint() });
    return data; // { total_unique, new_visitor }
  } catch (e) {
    return null;
  }
}

export async function fetchVisits() {
  try {
    const { data } = await apiClient.get('/visits');
    return data;
  } catch (e) {
    return { total_unique: 0 };
  }
}

// --- Geocoding heuristique (lat/lng par location FR) ---
// Petite map de lieux fréquents pour positionner sur le globe
const GEO = {
  'syrie': [35.0, 38.0], 'syria': [35.0, 38.0],
  'émirats': [24.46, 54.37], 'eau': [24.46, 54.37], 'uae': [24.46, 54.37],
  'grèce': [38.0, 24.0], 'greece': [38.0, 24.0],
  'irak': [33.3, 44.4], 'iraq': [33.3, 44.4],
  'iran': [32.0, 53.0],
  'soudan': [12.0, 30.0], 'afrique': [12.0, 30.0],
  'japon': [35.68, 139.76], 'japan': [35.68, 139.76],
  'porto rico': [18.43, -67.15], 'puerto rico': [18.43, -67.15],
  'mexico': [19.43, -99.13], 'mexique': [19.43, -99.13],
  'tbilissi': [41.71, 44.83], 'géorgie': [41.71, 44.83],
  'achgabat': [37.95, 58.38], 'turkménistan': [37.95, 58.38],
  'kazakhstan': [48.0, 67.0],
  'washington': [38.89, -77.04], 'arizona': [33.45, -112.07], 'phoenix': [33.45, -112.07],
  'pacifique': [33.0, -119.0], 'pacific': [33.0, -119.0],
  'atlantique': [33.0, -77.0], 'atlantic': [33.0, -77.0],
  'middle east': [33.3, 44.4], 'moyen-orient': [33.3, 44.4], 'moyen orient': [33.3, 44.4],
  'roswell': [33.39, -104.52],
  'arctique': [78.0, 16.0], 'antarctique': [-80.0, 0.0],
  "ouest des états-unis": [39.7, -111.0], 'western us': [39.7, -111.0], 'western united states': [39.7, -111.0],
  'états-unis': [40.0, -100.0], 'united states': [40.0, -100.0], 'us': [40.0, -100.0],
  'indo-pacifique': [10.0, 140.0], 'indopacom': [10.0, 140.0],
  'corée du sud': [37.5, 127.0], 'corée': [37.5, 127.0],
  'australie': [-25.0, 134.0],
  'israël': [31.5, 34.75],
  'lune': [0, 0], 'moon': [0, 0], 'orbite': [0, 0],
};

export function geoForLocation(loc) {
  if (!loc) return null;
  const l = loc.toLowerCase();
  for (const k of Object.keys(GEO)) {
    if (l.includes(k)) return GEO[k];
  }
  return null;
}
